const DeviceMobileMixin = {
  async _onMobile() {
    const platform = await Median.getPlatform(); // "ios" | "android" | "web"
    return ['ios', 'android'].includes(platform);
  },

  _debug(message) {
    if (this.constructor.DEBUG_MODE) {
      console.log(message);
    }
  },

  async _getDeviceInfo() {
    const info = await Median.onesignal.info();
    this._debug(`info response: ${JSON.stringify(info)}`);
    // Device info: {
    //   "osVersion": "26.3",
    //   "language": "fr-FR",
    //   "appBuild": "18",
    //   "subscription": {
    //     "id": "b735bca6-cd28-44a7-8998-5d661d7efdd2",
    //     "token": "b6156a00f8930ae398e7f8c9cc43f8b03237e2e3f010b5a7b0ffd035945fa07e",
    //     "optedIn": true
    //   },
    //   "distribution": "debug",
    //   "oneSignalId": "47b2dc2a-5a36-4e02-96c8-16686b747f69",
    //   "carrierNames": [
    //     "--",
    //     "--"
    //   ],
    //   "deviceName": "iPhone",
    //   "legacy": false,
    //   "carrierName": "--",
    //   "appVersion": "1.0.0",
    //   "os": "iOS",
    //   "isFirstLaunch": true,
    //   "platform": "ios",
    //   "hardware": "iPhone18,3",
    //   "timeZone": "Europe/Paris",
    //   "publicKey": "nowwoj",
    //   "model": "iPhone",
    //   "appId": "co.median.ios.nowwoj",
    //   "requiresUserPrivacyConsent": true,
    //   "externalId": "hugo@lapremierebriquer.fr",
    //   "installationId": "4A702FBB-BBFB-43BD-A399-85F69A939815"
    // }
    return {
      oneSignalId: info?.oneSignalId,
      externalId: info?.externalId,
      deviceName: info?.deviceName,
      subscriptionId: info?.subscription?.id,
      installationId: info?.installationId,
      platform: info?.platform,
      os: info?.os,
      osVersion: info?.osVersion
    };
  },

  async _registerDevice(params) {
    try {
      const response = await fetch(this.createDeviceUrlValue, {
        method: 'POST',
        body: JSON.stringify({device: params}),
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
      });
      this._debug('BO response code: ' + response.status);
      this._handleServerError(response);
    } catch (error) {
      this._debug('Error registering device: ' + error.message);
      this._handleServerError();
    }
  },

  async _alreadyAcceptedOrRefused(type) {
    const info = await this._getDeviceInfo();
    try {
      const params = new URLSearchParams({installation_id: info.installationId});
      const response = await fetch(`${this.getDevicesUrlValue}?${params}`, {
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        }
      });
      this._debug('BO response code: ' + response.status);
      this._handleServerError(response);

      const results = await response.json();
      this._debug('BO response: ' + JSON.stringify(results));

      if (results.length === 0) return false;
      return results[0][`${type}_accepted_at`] || results[0][`${type}_refused_at`];
    } catch (error) {
      this._debug('Error registering device: ' + error.message);
      this._handleServerError();
    }
    return true;
  },

  _handleServerError(response = null) {
    if (response?.ok) return;
    location.reload();
  }
};

export default DeviceMobileMixin
